import React, { useState } from 'react';
import Modal from './Modal';
import TextInput from './TextInput';
import useBusinessPostApi from '../lib/useBusinessPostApi';
import * as Toast from '../lib/Toast';
import { setBusinessInfo } from '../lib/Queries';
import InputLabel from './InputLabel';

const PhysicalAddressModal = ({ isOpen, onClose, onSuccess }) => {
    const [physicalAddress, setPhysicalAddress] = useState('');
    const [errors, setErrors] = useState({});
    const { save, isSaving } = useBusinessPostApi('/update-business-address');

    const validateAddress = (address) => {
        const errors = {};
        const trimmedAddress = address.trim();

        if (!trimmedAddress) {
            errors.physical_address = 'Address is required';
            return errors;
        }

        if (trimmedAddress.length < 10) {
            errors.physical_address = 'Please enter a complete address (at least 10 characters)';
            return errors;
        }

        // Basic validation for address components
        const hasNumber = /\d/.test(trimmedAddress);
        const hasComma = trimmedAddress.includes(',');

        if (!hasNumber) {
            errors.physical_address = 'Address should include a street number';
            return errors;
        }

        if (!hasComma) {
            errors.physical_address = 'Please include city and state/country (separated by commas)';
            return errors;
        }

        return errors;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const validationErrors = validateAddress(physicalAddress);
        setErrors(validationErrors);

        if (Object.keys(validationErrors).length > 0) {
            return;
        }

        try {
            const result = await save({
                physical_address: physicalAddress.trim(),
            });

            setBusinessInfo(result);
            Toast.success('Address saved successfully');
            onSuccess?.(result);
            onClose();
        } catch (error) {
            if (error.response?.data?.errors) {
                setErrors(error.response.data.errors);
            } else {
                Toast.error('Failed to save address. Please try again.');
            }
        }
    };

    const handleClose = () => {
        setPhysicalAddress('');
        setErrors({});
        onClose();
    };

    return (
        <Modal isOpen={isOpen} onClose={handleClose} className="max-w-lg">
            <div className="">
                <h2 className="text-xl font-semibold mb-4">
                    Business Physical Address Required
                </h2>

                <div className="mb-4 text-gray-600">
                    <p className="mb-2">
                        To comply with international anti-spam laws (CAN-SPAM, GDPR, etc.),
                        a physical business address is required for marketing emails.
                    </p>
                </div>

                <InputLabel 
                    showTooltip={true}
                    message="This address will be displayed in email footers and is <br>required before you can use marketing automations."
                >
                    Business Physical Address
                </InputLabel>
                <form onSubmit={handleSubmit}>
                    <TextInput
                        //label="Business Physical Address"
                        value={physicalAddress}
                        onChange={setPhysicalAddress}
                        placeholder="123 Main St, City, State 12345, Country"
                        error={errors.physical_address}
                        className="mb-4"
                        required
                        autoFocus
                    />

                    <div className="flex space-x-3">
                        <button
                            type="submit"
                            className="btn-save"
                            disabled={isSaving}
                        >
                            {isSaving ? 'Saving...' : 'Save Address'}
                        </button>
                    </div>
                </form>
            </div>
        </Modal>
    );
};

export default PhysicalAddressModal;
